/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios');

window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const token = localStorage.getItem('token');

if (token) {
    window.axios.defaults.headers['Authorization'] = `Bearer ${token}`;
}

// window.axios.defaults.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');
window.axios.defaults.baseURL = `${process.env.MIX_APP_URL}/api`;

axios.interceptors.request.use(config => {
    // Do something before request is sent
    return config;
}, error => {
    // Do something with request error
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    return response;
}, error => {
    const { status } = error.response;

    if (status == 401) {
        localStorage.removeItem('token');

        // let loginRetry = localStorage.getItem('login-retry') ?? 0

        // if (loginRetry >= 2) {
        //     localStorage.removeItem('login-retry')

        //     window.location.href = '/internal-error'

        //     return
        // }

        // localStorage.setItem('login-retry', ++loginRetry);
        window.location.href = '/';

        return
    }

    return Promise.reject(error);
});
